export default "/images/63bfd8a4d9f6d50e8014635f32547bd0.avif";